import React from 'react'
import icon from './svgs/cupgold.svg'
import { BaseIcon } from './_base'

export const CupGoldIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
